export const buildProvenance = { "commitHash": "761ab1228614662a85cd5cd7681b6d044e6e7188", "branchName": "refs/heads/release/2023.4", "buildDate": "2024-02-08T05:18:33.158Z", "version": "2023.4.8313" };
